import { render, staticRenderFns } from "./CDLastCommitsSection.vue?vue&type=template&id=e61dce6a&scoped=true"
import script from "./CDLastCommitsSection.vue?vue&type=script&lang=ts"
export * from "./CDLastCommitsSection.vue?vue&type=script&lang=ts"
import style0 from "./CDLastCommitsSection.vue?vue&type=style&index=0&id=e61dce6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61dce6a",
  null
  
)

export default component.exports